import axios from "axios";
import settings from "../../../../utils/settings";

const url = `${settings.accountsUrl}api/admin/news`;

export const addNews = (news) => {
    return axios.post(`${url}`, news);
}


// WEBPACK FOOTER //
// ./src/views/pages/news/requests/addNews.js